import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/src/app/error.tsx");
